/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Empty_UsageInputs */

const vi_my_grower_report_empty_usage = /** @type {(inputs: My_Grower_Report_Empty_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có nhật ký dùng vật tư nhóm này trong khoảng thời gian trên.`)
};

/**

* @param {My_Grower_Report_Empty_UsageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_empty_usage = /** @type {((inputs?: My_Grower_Report_Empty_UsageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Empty_UsageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_empty_usage(inputs)
});